export default "__VITE_ASSET__EbcXS2Q3__"